__webpack_require__.S = {};
var initPromises = {};
var initTokens = {};
__webpack_require__.I = function(name, initScope) {
	if(!initScope) initScope = [];
	// handling circular init calls
	var initToken = initTokens[name];
	if(!initToken) initToken = initTokens[name] = {};
	if(initScope.indexOf(initToken) >= 0) return;
	initScope.push(initToken);
	// only runs once
	if(initPromises[name]) return initPromises[name];
	// creates a new share scope if needed
	if(!__webpack_require__.o(__webpack_require__.S, name)) __webpack_require__.S[name] = {};
	// runs all init snippets from all modules reachable
	var scope = __webpack_require__.S[name];
	var warn = function(msg) { return typeof console !== "undefined" && console.warn && console.warn(msg); };
	var uniqueName = "game";
	var register = function(name, version, factory, eager) {
		var versions = scope[name] = scope[name] || {};
		var activeVersion = versions[version];
		if(!activeVersion || (!activeVersion.loaded && (!eager != !activeVersion.eager ? eager : uniqueName > activeVersion.from))) versions[version] = { get: factory, from: uniqueName, eager: !!eager };
	};
	var initExternal = function(id) {
		var handleError = function(err) { warn("Initialization of sharing external failed: " + err); };
		try {
			var module = __webpack_require__(id);
			if(!module) return;
			var initFn = function(module) { return module && module.init && module.init(__webpack_require__.S[name], initScope); }
			if(module.then) return promises.push(module.then(initFn, handleError));
			var initResult = initFn(module);
			if(initResult && initResult.then) return promises.push(initResult['catch'](handleError));
		} catch(err) { handleError(err); }
	}
	var promises = [];
	switch(name) {
		case "default": {
			register("board", "0.0.0", function() { return Promise.all([__webpack_require__.e(206), __webpack_require__.e(487), __webpack_require__.e(818)]).then(function() { return function() { return __webpack_require__(81818); }; }); });
			register("business-logic", "0.0.0", function() { return __webpack_require__.e(968).then(function() { return function() { return __webpack_require__(96968); }; }); });
			register("react-dom", "18.1.0", function() { return Promise.all([__webpack_require__.e(749), __webpack_require__.e(206)]).then(function() { return function() { return __webpack_require__(15749); }; }); });
			register("react", "18.1.0", function() { return __webpack_require__.e(969).then(function() { return function() { return __webpack_require__(30969); }; }); });
			register("store", "0.0.0", function() { return Promise.all([__webpack_require__.e(206), __webpack_require__.e(894)]).then(function() { return function() { return __webpack_require__(66894); }; }); });
			register("ui", "0.0.0", function() { return Promise.all([__webpack_require__.e(435), __webpack_require__.e(206), __webpack_require__.e(145)]).then(function() { return function() { return __webpack_require__(21298); }; }); });
		}
		break;
	}
	if(!promises.length) return initPromises[name] = 1;
	return initPromises[name] = Promise.all(promises).then(function() { return initPromises[name] = 1; });
};